import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ChargeCodesActions } from '../StoreAdapter'
import { ChargeCodeSchema } from '../../../Schema/ChargeCodeSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ChargeCodesAPI } from '../../../Services/API/ChargeCodesAPI'

export const useUpdateChargeCode = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const updateChargeCode = useCallback(
    async (schema: ChargeCodeSchema): Promise<ChargeCodeSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ChargeCodesAPI)
        .updateEntity(schema)
        .then((schema) => {
          dispatch(ChargeCodesActions.updateOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err.message)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    updateChargeCode,
  }
}
